import 'bootstrap-daterangepicker';
import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import moment from 'moment';

export default class extends Controller {
  static targets = ['input', 'trigger', 'startDate', 'endDate'];

  connect() {
    const self = this;
    self.pickerDirection = self.inputTarget.dataset.pickerDirection || 'right';
    self.datepickerOptions = {
      format: 'YYYY-MM-DD',
      timePicker: false,
      opens: self.pickerDirection,
      alwaysShowCalendars: true,
      cancelButtonClasses: 'btn btn-cancel',
      autoApply: false,
      ranges: {
        Yesterday: [moment().subtract('days', 1), moment().subtract('days', 1)],
        'Last 7 Days': [
          moment().subtract('days', 7),
          moment().subtract('days', 1),
        ],
        'Last 30 Days': [
          moment().subtract('days', 30),
          moment().subtract('days', 1),
        ],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
          moment().subtract('month', 1).startOf('month'),
          moment().subtract('month', 1).endOf('month'),
        ],
        'This Year': [moment().startOf('year'), moment().subtract('days', 1)],
        'Last Year': [
          moment().subtract('year', 1).startOf('year'),
          moment().startOf('year').subtract('days', 1),
        ],
      },
    };
    $(self.inputTarget).daterangepicker(self.datepickerOptions);
    $(self.triggerTarget).on('click', () => {
      self.inputTarget.focus();
    });
  }
}
